import QRCode from 'qrcode';

/** Quiet zone in modules — 4 is the ISO/IEC 18004 minimum for reliable scanning. */
export const QR_QUIET_ZONE = 4;

export interface QrVector {
  /** Width/height of the square viewBox, quiet zone included. */
  viewBoxSize: number;
  /** One SVG path covering every dark module. */
  path: string;
}

/**
 * Encodes `value` into a vector QR code. Synchronous so the card never renders
 * (or exports) a half-loaded QR. Error correction M keeps modules large at
 * card size; there is no logo overlay that would need level H.
 */
export function buildQrVector(value: string): QrVector {
  const { modules } = QRCode.create(value, { errorCorrectionLevel: 'M' });
  const { size, data } = modules;
  let path = '';

  for (let y = 0; y < size; y++) {
    let x = 0;
    while (x < size) {
      if (!data[y * size + x]) {
        x++;
        continue;
      }
      const start = x;
      while (x < size && data[y * size + x]) x++;
      const run = x - start;
      path += `M${start + QR_QUIET_ZONE} ${y + QR_QUIET_ZONE}h${run}v1h-${run}z`;
    }
  }

  return { viewBoxSize: size + QR_QUIET_ZONE * 2, path };
}
